import { render, staticRenderFns } from "./WebsiteCrudForm.vue?vue&type=template&id=601645cb&scoped=true"
import script from "./WebsiteCrudForm.vue?vue&type=script&lang=js"
export * from "./WebsiteCrudForm.vue?vue&type=script&lang=js"
import style0 from "./WebsiteCrudForm.vue?vue&type=style&index=0&id=601645cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601645cb",
  null
  
)

export default component.exports